<template>
  <div class="wrapper-keyword" v-if="isShowKeyword">
    <div class="flex gap-2 items-center mt-3">
      {{ $i18nPresenter.t('Or try') }}:
      <div v-for="(keyword, index) in keywords" :key="index">
        <aha-tag
          :size="'sm'"
          class="h-6"
          @click="onKeywordClicked(keyword)"
          v-aha-emit-action
          name="keyword_suggestion"
        >
          {{ keyword }}
        </aha-tag>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import OpenAIApi from '@/api/openai'
import { ALLOWED_OBJECT_TYPE, ALLOWED_ACTION_TYPE } from '@/constant/aiAction'

export default {
  props: {
    uploadType: {
      type: String,
      default: null,
    },
    slideOptionId: {
      type: Number,
      default: null,
    },
  },

  computed: {
    ...mapState('imageKeywordSuggestions', ['keywords', 'applyKeyword']),
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),

    isShowKeyword() {
      return this.keywords.length > 0
    },

    objectType() {
      if (this.uploadType?.toLowerCase()?.includes('slide')) {
        return ALLOWED_OBJECT_TYPE.SLIDE
      }

      if (this.uploadType?.toLowerCase()?.includes('option')) {
        return ALLOWED_OBJECT_TYPE.SLIDE_OPTIONS
      }

      return ''
    },

    objectId() {
      if (this.objectType === ALLOWED_OBJECT_TYPE.SLIDE) {
        return this.slideActive?.id
      }
      return this.slideOptionId
    },
  },
  destroyed() {
    this.clearKeywords()
  },
  methods: {
    ...mapActions('imageKeywordSuggestions', ['setApplyKeyword', 'clearKeywords']),

    onKeywordClicked(keyword) {
      this.setApplyKeyword(keyword)

      OpenAIApi.trackAIAction({
        objectId: this.objectId,
        objectType: this.objectType,
        actionType: ALLOWED_ACTION_TYPE.IMAGE_KEYWORD,
        actionDetail: {
          value: keyword,
          type: this.uploadType,
        },
      })
    },
  },

}
</script>
<style>
.wrapper-keyword {
  width: 40%;
  margin: 0 auto;
  display: flex;
}
</style>
